import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

// --- TODOS TUS IMPORTS DE IMÁGENES (Mantener exactamente igual) ---
import d1slider1 from "../assets/d1slider1.webp"
import d1slider2 from "../assets/d1slider2.webp"
import d2slider1 from "../assets/d2slider1.webp"
import d2slider2 from "../assets/d2slider2.webp"
import d2slider3 from "../assets/d2slider3.webp"
import d2slider4 from "../assets/d2slider4.webp"
import d2slider5 from "../assets/d2slider5.webp"
import d2slider6 from "../assets/d2slider6.webp"
import d2slider7 from "../assets/d2slider7.webp"
import d2slider8 from "../assets/d2slider8.webp"
import d3slider1 from "../assets/d3slider1.webp"
import d3slider2 from "../assets/d3slider2.webp"
import d3slider3 from "../assets/d3slider3.webp"
import d3slider4 from "../assets/d3slider4.webp"
import d3slider5 from "../assets/d3slider5.webp"
import d3slider6 from "../assets/d3slider6.webp"
import d3slider7 from "../assets/d3slider7.webp"
import d3slider8 from "../assets/d3slider8.webp"
import d4slider1 from "../assets/d4slider1.webp"
import d4slider2 from "../assets/d4slider2.webp"
import d4slider3 from "../assets/d4slider3.webp"
import d4slider4 from "../assets/d4slider4.webp"
import d5slider1 from "../assets/d5slider1.webp"
import d5slider2 from "../assets/d5slider2.webp"
import d5slider3 from "../assets/d5slider3.webp"
import d5slider4 from "../assets/d5slider4.webp"
import d6slider1 from "../assets/d6slider1.webp"
import d6slider2 from "../assets/d6slider2.webp"
import d6slider3 from "../assets/d6slider3.webp"
import d6slider4 from "../assets/d6slider4.webp"
import d6slider5 from "../assets/d6slider5.webp"
import d7slider1 from "../assets/d7slider1.png"
import d7slider2 from "../assets/d7slider2.png"
import d7slider3 from "../assets/d7slider3.png"
import d7slider4 from "../assets/d7slider4.png"
import d7slider5 from "../assets/d7slider5.png"
import d7slider6 from "../assets/d7slider6.png"
import d7slider7 from "../assets/d7slider7.png"
import d8slider1 from "../assets/d8slider1.png"
import d8slider2 from "../assets/d8slider2.png"
import d8slider3 from "../assets/d8slider3.png"
import d8slider4 from "../assets/d8slider4.png"
import d9slider1 from "../assets/d9slider1.png"
import d9slider2 from "../assets/d9slider2.png"
import d9slider3 from "../assets/d9slider3.png"
import d9slider4 from "../assets/d9slider4.png"
import d9slider5 from "../assets/d9slider5.png"
import d9slider6 from "../assets/d9slider6.png"
import d9slider7 from "../assets/d9slider7.png"
import d9slider8 from "../assets/d9slider8.png"
import d9slider9 from "../assets/d9slider9.png"
import d9slider10 from "../assets/d9slider10.png"
import d10slider1 from "../assets/d10slider1.png"
import d11slider1 from "../assets/d11slider1.jpg"

import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import { useState } from 'react';

// Componente Reutilizable para Reconocimientos
const ReconocimientoCard = ({ titulo, parrafo, imagenes, linkVerMas }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => setIsOpen(!isOpen);

  const textoCorto = parrafo.length > 150 ? parrafo.substring(0, 150) + "..." : parrafo;

  return (
    <div className='w-full max-w-[1200px] mx-auto mb-16 px-4'>
      <div className='bg-white rounded-[2rem] shadow-xl overflow-hidden border border-slate-100 flex flex-col lg:flex-row transition-all duration-500 hover:shadow-2xl'>

        {/* Carrusel */}
        <div className='lg:w-1/2 bg-slate-100'>
          <Carousel showStatus={false} showThumbs={false} infiniteLoop autoPlay interval={5000} className='h-full'>
            {imagenes.map((img, index) => (
              <div key={index} className='h-[300px] lg:h-[450px]'>
                <img src={img} alt="Galería" className='object-cover h-full w-full' />
              </div>
            ))}
          </Carousel>
        </div>

        {/* Contenido Minimizado */}
        <div className='lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center'>
          <h2 className='text-3xl font-bold text-slate-800 mb-6'>{titulo}</h2>
          <p className='text-slate-600 leading-relaxed text-justify font-light text-lg'>
            {textoCorto}
          </p>

          <div className='flex flex-wrap gap-4 mt-8'>
            <button
              onClick={toggleModal}
              className='bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-xl font-bold shadow-lg transition-all active:scale-95'
            >
              Ver historia completa
            </button>
            {linkVerMas && (
              <a href={linkVerMas} target='_blank' rel="noreferrer" className='bg-slate-900 text-white px-8 py-3 rounded-xl font-bold'>
                Enlace
              </a>
            )}
          </div>
        </div>
      </div>

      {/* MODAL ESTILO BOTTOM-SHEET (Móvil desde abajo, Desktop centrado) */}
      {isOpen && (
        <div className='fixed inset-0 z-[999] flex items-end md:items-center justify-center bg-black/60 backdrop-blur-sm p-0 md:p-6'>

          {/* Fondo para cerrar al hacer clic afuera */}
          <div className='absolute inset-0' onClick={toggleModal}></div>

          <div className='relative bg-white w-full md:max-w-2xl rounded-t-[2.5rem] md:rounded-[2.5rem] shadow-2xl p-8 md:p-12 animate-slideUp md:animate-fadeIn max-h-[90vh] overflow-y-auto'>

            {/* Indicador visual de "arrastre" para móviles */}
            <div className='w-12 h-1.5 bg-slate-200 rounded-full mx-auto mb-6 md:hidden'></div>

            <button
              onClick={toggleModal}
              className='hidden md:block absolute top-6 right-6 text-slate-400 hover:text-red-500 text-2xl font-black'
            >
              ✕
            </button>

            <h3 className='text-2xl md:text-3xl font-bold text-slate-900 mb-6'>{titulo}</h3>

            <p className='text-slate-600 text-lg leading-relaxed text-justify italic border-l-4 border-blue-600 pl-4 py-2'>
              {parrafo}
            </p>

            <button
              onClick={toggleModal}
              className='w-full mt-8 bg-slate-900 text-white py-4 rounded-2xl font-bold md:hidden'
            >
              Cerrar historia
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const Docentes = () => {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <div className='bg-slate-50 pt-32 pb-16 overflow-hidden'>

        {/* Encabezado */}
        <div className='max-w-[1240px] mx-auto text-center mb-20 px-4'>
          <h1 className="text-4xl md:text-7xl font-black text-slate-900 tracking-tighter uppercase italic">
            Reconocimientos
          </h1>
          <div className='flex justify-center items-center gap-3 mt-4'>
            <div className='h-[3px] w-10 bg-blue-600 rounded-full'></div>
            <p className='text-slate-500 font-medium tracking-widest text-sm uppercase'>Vida y Obra del Pedagogo</p>
            <div className='h-[3px] w-10 bg-blue-600 rounded-full'></div>
          </div>
        </div>

        {/* Listado de Secciones */}
        <ReconocimientoCard
          titulo="Reconocimiento a la visión"
          parrafo="Reconocimiento al Director Javier Duque por su invaluable liderazgo y visión al frente de esta Fundación. Gracias por convertir la gratitud hacia los docentes en una misión de vida y por ser el motor que dignifica y exalta la labor de quienes forman las nuevas generaciones. Su gestión no solo fortalece la educación, sino que inspira a toda la comunidad educativa."
          imagenes={[d11slider1]}
        />

        <ReconocimientoCard
          titulo="Reconocimiento a docentes"
          parrafo="Reconocimiento y acompañamiento al Docente Héctor A. Iriarte Martinez, nació en Cartagena, vivió por más de 27 años en el barrio Nelson Mandela, junto a sus padres y cuatro hermanos. Fue allí en el Barrio Nelson Mandela donde construye su proyecto musical para el benéfico de esta comunidad en especial para los niños y jóvenes, con quienes construye su propuesta de carácter educativo - recreacional marcado por el aprendizaje para tocar instrumentos musicales y participar en grupos musicales. Actualmente ya no vive el barrio, pero pasa la mayor parte del tiempo en Nelson Mandela, ya que allí está su Fundación Colectivo Canta y a la cual le dedica gran parte de su esfuerzo, trabajando por la comunidad."
          imagenes={[d9slider1, d9slider2, d9slider3, d9slider4, d9slider5, d9slider6, d9slider7, d9slider8, d9slider9, d9slider10]}
        />

        <ReconocimientoCard
          titulo="Reconocimiento a docentes"
          parrafo="El dia 13 de Octubre de 2021 se acompañó y resaltó la labor del Docente y Deportista Francisco Castell, su amplia trayectoria como jugador de fútbol en la rama aficionada y profesional en varios equipos a nivel nacional e internacional entre esos el Junior de Barranquilla, y los años como docente en las áreas deportivas en diferentes instituciones educativas y escuelas de fútbol, fueron reconocidas a Francisco Castell"
          imagenes={[d1slider1, d1slider2]}
        />

        <ReconocimientoCard
          titulo="Premiación a docentes"
          parrafo="A través del Premio a la Vida y Obra del Pedagogo reconocemos y exaltamos a aquellos docentes cuya labor impacta en los estudiantes, institución en la que labora y comunidad donde se desempeña, con trabajos de tipo académico, cultural, social, o de mejoramiento de calidad de vida."
          imagenes={[d2slider1, d2slider2, d2slider3, d2slider4, d2slider5, d2slider6, d2slider7, d2slider8]}
        />

        <ReconocimientoCard
          titulo="Reconocimiento a docentes"
          parrafo="En los IV Juegos Deportivos Nacionales LaSallistas se hace un reconocimiento a la labor del docente Luis Noriega por su destacado desempeño en la realización de esta actividad."
          imagenes={[d3slider1, d3slider2, d3slider3, d3slider4, d3slider5, d3slider6, d3slider7, d3slider8]}
        />

        <ReconocimientoCard
          titulo="Reconocimiento a docentes"
          parrafo="En el municipio Sucre perteneciente al departamento de Sucre se hace entrega en presencia del Secretario de Educación del municipio Jose Miguel Sánchez de una placa de reconocimiento al docente Isidro Manuel Álvarez Jaraba por su vocación de docente en la conservación y divulgación de los orígenes de la obra literaria del Premio Nobel Gabriel García Márquez."
          imagenes={[d4slider2, d4slider1, d4slider3, d4slider4]}
          linkVerMas="http://sucresucrerutamagicagabo.blogspot.com/?m=1"
        />

        <ReconocimientoCard
          titulo="Brindis con docentes"
          parrafo="En el Club ABC de la ciudad de Barranquilla, se realiza un brindis en compañia de directivos de la Fundación y los docentes ganadores del Premio a la Vida y Obra del Pedagogo."
          imagenes={[d5slider1, d5slider2, d5slider3, d5slider4]}
        />

        <ReconocimientoCard
          titulo="Reconocimiento a docentes"
          parrafo="Reconocimiento y acompañamiento al Docente Everth de Jesús Ortega Vizcaino. Proyecto ambiental Nueva Venecia. Extracción de botellas y plástico de la Ciénaga Grande del Magdalena. Se resalta la labor ambiental, donde se genera en la comunidad conciencia y acciones para limpiar la ciénaga grande del Magdalena, de la contaminación de plásticos y botellas, las cuales están deteriorando de manera dramática la vida y ecosistema de la ciénaga grande del Magdalena."
          imagenes={[d6slider1, d6slider2, d6slider3, d6slider4, d6slider5]}
        />

        <ReconocimientoCard
          titulo="Reconocimiento a docentes"
          parrafo="Reconocimiento y acompañamiento al Docente Rodolfo A. Coneo Martinez el cual ha sido calificado y catalogado en diferentes ocasiones como un excelente Docente Policial por la comunidad Académica de los aspirantes a patrulleros de la Policía Nacional y además ha sido objeto de reconocimiento hasta por tercera vez 3ª con la medalla denominada (AL MERITO DOCENTE DOCTOR GABRIEL GONZALEZ LOPEZ), la cual se reconoce al interior de la education polical como el máximo galardon de calidad otorgado a los docentes policiales seleccionados y escogidos a nivel nacional por su excelencia y destacada labor."
          imagenes={[d10slider1]}
        />

        <ReconocimientoCard
          titulo="Reconocimiento a docentes"
          parrafo="Reconocimiento y acompañamiento a la docente Martha De Leon Navarro, docente activa del Colegio La Salle de Barranquila, quien ha enfocado su labor educativa y de formación a los jóvenes en el cuidado del medio ambiente y recuperacionde las especies en vías de extinción. Corazones Verdes, trabajo comunitario para el rescate de manglares y especies en extincion."
          imagenes={[d7slider7, d7slider1, d7slider2, d7slider3, d7slider4, d7slider5, d7slider6]}
        />

        <ReconocimientoCard
          titulo="Reconocimiento a docentes"
          parrafo="Reconocimiento y acompañamiento al Docente Luis Fernando Castillo Fontalvo, docente por muchos años en los colegios de los Hermanos Cristianos de La Salle, Colegio Biffi, actualmente dentro de sus labores sociales y artísticas promueve actividades culturales con jóvenes de sectores populares. La arquitectura y las artes gráficas, aportes para las comunidades en desarrollo."
          imagenes={[d8slider1, d8slider2, d8slider3, d8slider4]}
        />

      </div>
      <Footer />
    </>
  );
};

export default Docentes;